import { store } from "./ConfigureStore";
// this function take the extracted data from the resume and dispatch them into their respective stores
import {
    personal_information,
    dispatchActivites,
    current_skills,
    currentExperience,
    dispatchSkills,
    dispatchPskills,
    dispatchEducation,
    currentEducation,
    Professional_summary,
    dispatchLanguage
} from "./ActionCreator"
import { saveIntoServerCache } from "../utils/saveIntoCache";

const PersonalInfo = (info) => async (dispatch) => {
    try {
        // let stor = store.getState()
        // let personal_info_store = stor.personal_info;
        let data = {
            Firstname: info.Fullname.split(" ")[0],
            LastName: info.Fullname.split(" ")[1],
            Address: info.Address,
            Email: info.Email,
            JobInterests: [info.CvType]
        }
        dispatch(personal_information(data))
        saveIntoServerCache("personalInfo", data);
    } catch (error) {
        console.log("error", error);
    }
}

const ExperienceInfo = (info) => async (dispatch) => {
    try {
        // let stor = store.getState()
        // let personal_info_store = stor.personal_info;
        let data = info.Experience;
        console.log("data", data);
        dispatch(dispatchActivites(data));
        dispatch(currentExperience(data[0]));
        saveIntoServerCache("experience", data);
    } catch (error) {
        console.log("error", error);
    }
}

const EducationInfo = (info) => async (dispatch) => {
    try {
        // let stor = store.getState()
        // let personal_info_store = stor.personal_info;
        let data = info.Education;
        dispatch(dispatchEducation(data));
        dispatch(currentEducation(data[0]));
        saveIntoServerCache("education", data);
    } catch (error) {
        console.log("error", error);
    }
}

const skills = (info) => async (dispatch) => {
    try {
        // let stor = store.getState()
        // let personal_info_store = stor.personal_info;
        let Tdata = info.Technical_skills;
        let Pdata = info.Personal_skills;
        dispatch(dispatchPskills(Pdata));
        dispatch(dispatchSkills(Tdata));
        // dispatch(current_skills([...Tdata, ...Pdata]));
        saveIntoServerCache("technicalSkills", Tdata);
        saveIntoServerCache("personalSkills", Pdata);

    } catch (error) {
        console.log("error", error);
    }
}

const summary = (info) => async (dispatch) => {
    try {
        // let stor = store.getState()
        // let personal_info_store = stor.personal_info;
        let data = info.Professional_summary;
        dispatch(Professional_summary(data));
        saveIntoServerCache("summary", data);
    } catch (error) {
        console.log("error", error);
    }
}

const langauge = (info) => async (dispatch) => {
    try {
        // let stor = store.getState()
        // let personal_info_store = stor.personal_info;
        let data = info.Language;
        console.log("language data", data);
        let save = new Array();
        if (data && data.length > 0) {
            for (let lang of data) {
                if ( typeof lang !== "object") {
                    save.push({language: lang, rate: ""})
                }
            }
        }
        dispatch(dispatchLanguage(save));
        saveIntoServerCache("language", save);

    } catch (error) {
        console.log("error", error);
    }
}

export const Distribute = (info) => async (dispatch) => {
    try {
        console.log("At distribute function", info);
        if (info) {
            dispatch(PersonalInfo(info));
            dispatch(ExperienceInfo(info));
            dispatch(EducationInfo(info));
            dispatch(skills(info));
            dispatch(summary(info));
            dispatch(langauge(info))
        } 
        saveIntoServerCache("step", 27)
    } catch (error) {
        console.log("Could not distribute the information --==>>", error);
    }
}